// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f67ad142","963":"7dfe14d0"}[chunkId] + ".chunk.js";
};